package com.meistercharts.charts.pv.roofPlanning

import it.neckar.geometry.Size
import it.neckar.open.formatting.format
import it.neckar.open.i18n.CurrentI18nConfiguration
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.lang.WhitespaceConfig
import it.neckar.open.unit.si.mm
import kotlinx.serialization.Serializable

/**
 * The size of a module
 */
@Serializable
data class ModuleSize(
  val longer: @mm Int,
  val shorter: @mm Int,
) {
  init {
    require(longer >= shorter) {
      "Longer ($longer) must >= shorter ($shorter)"
    }

    require(longer > 0.0) { "Longer <$longer> is too small" }
    require(shorter > 0.0) { "Longer <$shorter> is too small" }
  }

  /**
   * Returns the width of the module - respecting the orientation
   */
  fun width(orientation: ModuleOrientation): @mm Int {
    return when (orientation) {
      ModuleOrientation.Vertical -> shorter
      ModuleOrientation.Horizontal -> longer
    }
  }

  fun height(orientation: ModuleOrientation): @mm Int {
    return when (orientation) {
      ModuleOrientation.Vertical -> longer
      ModuleOrientation.Horizontal -> shorter
    }
  }

  fun format(i18nConfiguration: I18nConfiguration = CurrentI18nConfiguration, whitespaceConfig: WhitespaceConfig = WhitespaceConfig.NonBreaking): String {
    return buildString {
      append(longer.format(i18nConfiguration, whitespaceConfig))
      append(whitespaceConfig.smallSpace)
      append("mm")
      append(whitespaceConfig.space)
      append("x")
      append(whitespaceConfig.space)
      append(shorter.format(i18nConfiguration, whitespaceConfig))
      append(whitespaceConfig.smallSpace)
      append("mm")
    }
  }

  override fun toString(): String {
    return "${longer.format()}mm x ${shorter.format()}mm"
  }

  /**
   * Converts to a size object - respecting the orientation
   */
  fun toSize(orientation: ModuleOrientation): @mm Size {
    return Size(width(orientation), height(orientation))
  }
}
